import Vue from 'vue'
import Vuex from 'vuex'
import Bowser from 'bowser'
import services from '@/services'
import data from '@/data'
import helpers from '@/helpers'

Vue.use(Vuex)

function isTouchDevice () {
  try {
    document.createEvent('TouchEvent')
    return true
  } catch (e) {
    return false
  }
}

const defaultState = {
  transition: {
    type: 'default',
    entry: null,
    components: {
      default: null
    }
  },
  options: {},
  data: {},
  pages: {
    current: undefined,
    previous: undefined
  },
  ua: undefined,
  currentPage: null,
  loader: null,
  width: window.innerWidth,
  height: window.innerHeight
}

export default new Vuex.Store({
  state: defaultState,
  mutations: {
    SET_PAGE: (state, page) => {
      state.pages.previous = state.pages.current
      state.pages.current = page
    },
    SET_TRANSITION: (state, transition) => {
      state.transition = transition
    },
    SET_OPTIONS: (state, options) => {
      state.options = options
    },
    SET_USERAGENT: (state, ua) => {
      state.ua = ua
    }
  },
  actions: {
    setPage: ({ commit }, page) => {
      commit('SET_PAGE', page)
    },
    setTransition: ({ commit, state }, transition) => {
      commit('SET_TRANSITION', transition)
    },
    resetTransition: ({ commit }) => {
      commit('SET_TRANSITION', defaultTransition)
    },
    loadOptions: ({ commit, getters }) => {
      getters.get('options').then((options) => {
        commit('SET_OPTIONS', options)
      })
    },
    parseUserAgent: ({ commit }) => {
      const ua = Bowser.getParser(window.navigator.userAgent).parsedResult
      // Fix iPad detected as desktop
      if (ua.platform.type === 'desktop' && ua.platform.vendor === 'Apple' && isTouchDevice()) {
        ua.platform.type = 'tablet'
      }
      commit('SET_USERAGENT', ua)
    }
  },
  getters: {
    ml: state => state.pages.current ? state.pages.current.ml : undefined,
    transition: state => state.transition,
    options: state => state.options,
    ua: state => state.ua,
    get: (state) => async (type, id = undefined, slug = false) => {
      if (!state.data[type]) {
        state.data[type] = data.get(type)
      }

      return state.data[type].then((items) => {
        if (id) {
          if (slug) {
            return Array.from(items).filter(i => i.slug === id)[0]
          } else {
            return Array.from(items).filter(i => i.id === id)[0]
          }
        } else {
          return items
        }
      })
    }
  }
})
